export enum TabType {
  LOCK = "LOCK",
  UNLOCK = "UNLOCK",
}
